<template>
  <div>{{ statusCode }} {{ message }}</div>
</template>

<script>
export default {
  name: "ErrorLayout",
  props: {
    statusCode: {
      type: Number,
      required: false
    },
    message: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped></style>
